export default {
  dga: {
    title: 'Find a bookkeeper for DGA salary administration',
    subtitle:
      'Simply get in touch with qualified bookkeepers for DGA salary administration.',
    cta: 'Continue'
  },
  bookkeeping: {
    title: 'Bookkeeping',
    subtitle:
      'Your complete bookkeeping easily regulated by our specialists. Personal contact and advice to measure. Quality against a sharp price.',
    cta: 'Continue'
  },
  banner: {
    title: 'Paid applications can still be completed here..',
    body:
      'New applications must be submitted through our renewed platform. If you have any questions, feel free to schedule a consultation.',
    note: 'Please note. You may need to log in again.',
    cta: 'Schedule a call'
  }
};
